export default __webpack_public_path__ + "static/media/15_LeftToRightSquares_Right.eddb1c03.mp4";